import React, { PureComponent } from 'react';

const instances = new Map();

const bodyStyles = {};

class ScrollLock extends PureComponent {
    static registerInstance = instance => {
        if (instances.size === 0) {
            ScrollLock.setBodyOverflow(true);
        }

        instances.set(instance.$node, instance);
    }

    static unregisterInstance = instance => {
        instances.delete(instance.$node);

        if (instances.size === 0) {
            ScrollLock.setBodyOverflow(false);
        }
    }

    static setBodyOverflow(shouldLock) {
        if (shouldLock) {
            // save current styles
            bodyStyles.height = document.body.style.height;
            bodyStyles.position = document.body.style.position;
            bodyStyles.overflow = document.body.style.overflow;
            bodyStyles.right = document.body.style.right;
            bodyStyles.left = document.body.style.left;

            // apply lock scroll lock styles
            document.body.style.height = '100%';
            document.body.style.position = 'fixed';
            document.body.style.overflow = 'hidden';
            document.body.style.right = '0';
            document.body.style.left = '0';
        } else {
            // re-apply old styles
            document.body.style.height = bodyStyles.height;
            document.body.style.position = bodyStyles.position;
            document.body.style.overflow = bodyStyles.overflow;
            document.body.style.right = bodyStyles.right;
            document.body.style.left = bodyStyles.left;
        }
    }

    componentDidMount() {
        ScrollLock.registerInstance(this);
    }

    componentWillUnmount() {
        ScrollLock.unregisterInstance(this);
    }

    render() {
        return (
            <span
                ref={node => { this.$node = node; }}
                data-test="scroll-lock"
                hidden
            />
        );
    }
}

export {
    ScrollLock as default,
    ScrollLock,
};
